import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.common.black,
    width: "100%",
    paddingBottom: 16,
    borderBottom: "1px solid #e8e8e8",
  },
  paper: {
    padding: 32,
    boxShadow: "none",
    height: "100%",
    overflow: "scroll",
  },
  root: {
    height: "calc(100% - 70px)",
    width: "100%",
  }
}));